import {
    CommentFormModeEnum,
    useCommentModalState,
} from "../Modals/CommentFormModal/CommentFormModalOpenState";
import { MutableRefObject, useCallback } from "react";

const openCommentFormModal = useCommentModalState.getState().setIsOpen;
export const useCommentInputModalOpenCallback = (
    inputCatcherRef?: MutableRefObject<HTMLInputElement | null>,
) => {
    const openCommentInputModal = useCallback(
        (
            modalMode: CommentFormModeEnum = CommentFormModeEnum.TEXT,
            focusInput: boolean = true,
        ) => {
            if (
                focusInput &&
                (modalMode === CommentFormModeEnum.TEXT ||
                    modalMode === CommentFormModeEnum.LINKOUT)
            ) {
                inputCatcherRef?.current?.focus();
            }
            openCommentFormModal(true, modalMode);
        },
        [inputCatcherRef],
    );

    return {
        openCommentInputModal,
    };
};
